import React from 'react';

const SvgArrowDown = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    width={props.width || 12}
    height={props.width || 13}
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.36605 10.227L0.264458 4.96079C-0.0881526 4.59681 -0.0881526 4.00823 0.264458 3.64811L1.11222 2.77299C1.46483 2.409 2.03501 2.409 2.38387 2.77299L6 6.50581L9.61613 2.77299C9.96874 2.409 10.5389 2.409 10.8878 2.77299L11.7355 3.64811C12.0882 4.0121 12.0882 4.60068 11.7355 4.96079L6.63395 10.227C6.28884 10.591 5.71866 10.591 5.36605 10.227Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgArrowDown;
